module.exports = __webpack_public_path__ + "static/9.4_ancient_america_mayans-c5c22be73d994c0696ddef84919ef29c.pdf";